module.exports = __webpack_public_path__ + "static/media/pasta-king.b8bc509d.jpg";